import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ArrowRight } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const YoutubeIcon = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="white">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);

const ChannelsSection = () => {
  const [channels, setChannels] = useState([]);

  useEffect(() => {
    const fetchChannels = async () => {
      try {
        const res = await axios.get(`${API}/channels`);
        setChannels(res.data);
      } catch (err) {
        console.error('Failed to fetch channels:', err);
      }
    };
    fetchChannels();
  }, []);

  if (channels.length === 0) return null;

  return (
    <section
      id="channels"
      className="section-padding"
      data-testid="channels-section"
      style={{
        background: 'linear-gradient(180deg, #1a0e2e 0%, #0f0a1e 100%)',
      }}
    >
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: 'clamp(32px, 4vw, 48px)',
          fontWeight: 700,

          marginBottom: '12px',
        }}>
          Our <span style={{ color: '#ff0000' }}>Channels</span>
        </h2>
        <p style={{
          textAlign: 'center',
          fontSize: '15px',
          color: '#b0adc0',
          marginBottom: '12px',
        }}>
          Explore our YouTube channels and dive into hours of spiritual wisdom.
        </p>
        <div className="section-divider" style={{ marginBottom: '50px' }} />

        <div className="grid-channels">
          {channels.map((ch) => (
            <a
              key={ch.channel_id}
              href={ch.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`channel-card-${ch.channel_id}`}
              className="glass-card"
              style={{
                padding: '28px 24px',
                textDecoration: 'none',
                color: 'inherit',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                gap: '14px',
                transition: 'transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-6px)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              <div style={{
                width: '68px',
                height: '68px',
                borderRadius: '16px',
                background: 'linear-gradient(135deg, #ff0000, #cc0000)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 6px 24px rgba(255, 0, 0, 0.25)',
              }}>
                <YoutubeIcon size={36} />
              </div>

              <h3
                dir="rtl"
                style={{
                  fontSize: '20px',
                  fontWeight: 700,
                  color: '#ffffff',
                  fontFamily: 'Inter, sans-serif',
                }}
              >
                {ch.name}
              </h3>

              {ch.description && (
                <p
                  dir="rtl"
                  style={{
                    fontSize: '13px',
                    color: '#b0adc0',
                    lineHeight: 1.6,
                    fontFamily: 'Inter, sans-serif',
                  }}
                >
                  {ch.description}
                </p>
              )}

              <span style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                color: '#ff4d4d',
                fontSize: '13px',
                fontWeight: 600,
                marginTop: '4px',
              }}>
                Visit Channel <ArrowRight size={14} />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChannelsSection;
